import disbursementMdl from "./disbursement.mdl";
import transactionReportsMdl from "./transactionReports.mdl";

export default [...disbursementMdl, ...transactionReportsMdl];
